import {RealBackend} from "../../secondary/RealBackend";
import {PusherRealtimeGateway} from "../../secondary/PusherRealtimeGateway";
import {CognitoAuthGateway} from "../../secondary/CognitoAuthGateway";
import {ExpoExternalLink} from "../../secondary/ExpoExternalLink";
import Constants from "expo-constants";
import * as Notifications from "expo-notifications";
import { API_ENDPOINT, PUSHER_APP_KEY, PUSHER_CLUSTER } from '@env';

class ExpoNotificationsGateway {

    constructor() {
        Notifications.setNotificationHandler({
            handleNotification: async () => ({
                shouldShowAlert: true,
                shouldPlaySound: false,
                shouldSetBadge: false,
            }),
        });
    }

    async getToken() {
        if (Constants.isDevice) {
            const { status: existingStatus } = await Notifications.requestPermissionsAsync();
            let finalStatus = existingStatus;
            if (existingStatus !== 'granted') {
                const { status } = await Notifications.requestPermissionsAsync();
                finalStatus = status;
            }
            if (finalStatus !== 'granted') {
                return;
            }

            try {
                return (await Notifications.getExpoPushTokenAsync()).data;
            } catch {
                return;
            }

        } else {
            alert('Must use physical device for Push Notifications');
        }

        if (Platform.OS === 'android') {
            await Notifications.setNotificationChannelAsync('default', {
                name: 'default',
                importance: Notifications.AndroidImportance.MAX,
                vibrationPattern: [0, 250, 250, 250],
                lightColor: '#FF231F7C',
            });
        }
    }
}

class FCMNotificationsGateway {

    constructor() {
        Notifications.setNotificationHandler({
            handleNotification: async () => ({
                shouldShowAlert: true,
                shouldPlaySound: false,
                shouldSetBadge: false,
            }),
        });
    }

    async getToken() {
        if (Constants.isDevice) {
            const { status: existingStatus } = await Notifications.requestPermissionsAsync();
            let finalStatus = existingStatus;
            if (existingStatus !== 'granted') {
                const { status } = await Notifications.requestPermissionsAsync();
                finalStatus = status;
            }
            if (finalStatus !== 'granted') {
                return;
            }

            return (await Notifications.getDevicePushTokenAsync()).data;

        } else {
            alert('Must use physical device for Push Notifications');
        }

        if (Platform.OS === 'android') {
            await Notifications.setNotificationChannelAsync('default', {
                name: 'default',
                importance: Notifications.AndroidImportance.MAX,
                vibrationPattern: [0, 250, 250, 250],
                lightColor: '#FF231F7C',
            });
        }
    }
}

export const productionDependencies = {
    backend: new RealBackend('https://ofhuum7lnh.execute-api.us-west-1.amazonaws.com/dev/'),
    realtimeGateway: new PusherRealtimeGateway('629682a630dc1dc9248b', 'ap2'),
    authGateway: new CognitoAuthGateway,
    externalLink: new ExpoExternalLink,
    notificationsGateway: new ExpoNotificationsGateway
}
